import {useCallback} from "react";
import SwivuModal from "./SwivuModal.jsx";
import {WIDGET_KEYS} from "../../../other/constants/WidgetKeys.jsx";
import EditorBase from "../../../bryntum-lib/editors/base/EditorBase.jsx";
import {defaultCellRenderer, showToast} from "../../../other/utils/utils.jsx";
import {GRANTS} from "../../../other/constants/PrivilegeTypes.jsx";
import {copyEntityToOtherBoard} from "../../../network/network.jsx";
import {pluralize} from "../../../other/utils/otherUtils.jsx";

class SwivuTaskCopyMenuEditorPopup extends EditorBase {
  static get $name() {
    return "SwivuTaskCopyMenuEditorPopup";
  }

  static get type() {
    return WIDGET_KEYS.copyEntityEditorType;
  }

  static get configurable() {
    return {
      title: "",
      minWidth: "25em",
      minHeight: "400px",
      maxHeight: "100vh",
      height: "min(100vh, 400px)",
      closable: true,
      autoClose: false,
      draggable: true,
      modal: true,
      cls: "resize",
      items: {
        savedViewGrid: {
          selectionMode: {
            row: true,
            checkbox: {
              hideable: false,
            },
            rowCheckboxSelection: false,
            showCheckAll: true
          },
          type: WIDGET_KEYS.swivuGrid,
          features: {
            stripe: true,
            filter: false,
            group: false,
            sort: false,
            headerMenu: false,
            cellMenu: {
              disabled: true
            },
          },
          height: "100%",
          columns: [
            {
              id: "name",
              text: "Name",
              field: "name",
              flex: 1,
              editor: false
            },
          ],
          bbar: {
            items: {
              copyButton: {
                type: 'button',
                text: "Copy Selected",
                cls: "b-widget-copy-board-btn ml-auto",
                onClick: "up.onCopyHandler",

              }
            },
          }
        }
      }
    };
  }

  editRecord(record, context, otherParams) {
    super.editRecord(record, context, otherParams);

    const {savedViewGrid} = this.widgetMap;

    this.title = `Select board's to copy this "${defaultCellRenderer({ value: record.entity.name })}" to`;
    this.context = context;
    this.record = record;

    const boardsToHaveCopyAccess = context.boardManager.boardNameStore.records.filter(
      (board) => board.id !== context.selectedBoard.id && board.grants?.includes(GRANTS.grant_four)
    );
    savedViewGrid.store.data = boardsToHaveCopyAccess;
  }

  async onCopyHandler() {
    try {
      const selectedRecords = this.widgetMap.savedViewGrid.selectedRecords;
      if (selectedRecords.length) {
        await Promise.all(
          selectedRecords.map((board) => copyEntityToOtherBoard(this.record.entityType, this.record.entity.id, board.id))
        );
        showToast({
          msg: `The entity has been copied to the selected ${pluralize(selectedRecords.length, "board", "s")}`,
          type: "success"
        })
      }
    } catch (e) {
      showToast({msg: "Sorry, something went wrong, Unable to copy!", type: "error"})
    }
  }
}

SwivuTaskCopyMenuEditorPopup.initClass();

const SwivuTaskCopyMenuEditor = ({context, onClose, isShow, record, editorInstance}) => {
  const onShowHandler = useCallback((editor, otherParams = {}) => {
    editor.project = context.project;
    editor.editRecord(record, context, otherParams);
    editorInstance.editorRef = editor;
  });
  return (
    <SwivuModal
      widgetType={WIDGET_KEYS.copyEntityEditorType}
      isShow={isShow}
      onHide={onClose}
      onShow={onShowHandler}
    />
  );
}

export default SwivuTaskCopyMenuEditor;